export default {
    inserted: function (el, bindings, vnode) {
        // default append to <body>
        if(bindings.value){
            var container = bindings.value
                ? document.getElementById(bindings.value)
                : document.body
            if (container) {
                container.appendChild(el)                         // bottom of target
            } else {
                console.warn(
                    'v-' + name + ' target element id "' + bindings.value + '" not found.'
                )
            }
        }

    },
    updated: function (el, bindings, vnode) {
        if(bindings.value) {
            var container = bindings.value
                ? document.getElementById(bindings.value)
                : document.body
            if (container) {
                container.appendChild(el)                         // bottom of target
            } else {
                console.warn(
                    'v-' + name + ' target element id "' + bindings.value + '" not found.'
                )
            }
        }
        else{
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        }
    },
    unbind: function (el) {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }
}


// WEBPACK FOOTER //
// ./src/directives/TransferDom.js